import { Button, Col, Form, Input, message, Row } from 'antd'
import React from 'react'
import { gql, useMutation } from '@apollo/client'
import { initializeApollo, addApolloState } from 'util/apolloClient'
import Router from 'next/router'
import ApplicationLayout from 'layouts/application'
import { Base_QueryDocument } from 'graphql/generated/types'

const FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      ok
    }
  }
`

const ForgotPassword = (props) => {
  const [forgotPassword, { data }] = useMutation(FORGOT_PASSWORD_MUTATION)

  const { data: pageData } = props

  const {
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_pages: { data: allPages },
  } = pageData

  if (data && data.forgotPassword.ok) {
    message.success('Email Successfully Sent')
    Router.push('/auth/signin')
  }

  const onFinish = (values) => {
    forgotPassword({
      variables: {
        email: values.email,
      },
    }).catch((err) => {
      message.info(err.message)
    })
  }

  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Row
        style={{
          marginTop: '32px',
          justifyContent: 'center',
          padding: '48px',
        }}
      >
        <Col xs={18} lg={8}>
          <div
            style={{ marginBottom: '16px', display: 'flex', fontSize: '24px' }}
          >
            <b>Reset Password</b>
          </div>
          <Form name="basic" onFinish={onFinish}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  message: 'Please input your email!',
                },
              ]}
            >
              <Input placeholder="email" />
            </Form.Item>

            <Form.Item style={{ justifyContent: 'flex-end' }}>
              <Button type="primary" htmlType="submit">
                Send Reset Link
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </ApplicationLayout>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const queryResults = await apolloClient.query({
    query: Base_QueryDocument,
  })
  const { data } = queryResults

  return addApolloState(apolloClient, { props: { data } })
}

export default ForgotPassword
